import { getExcludedIdsSearchCondition, isActiveSearchCondition } from "@gtmhub/shared/utils/search-utils";
import { ISearchCondition, ISearchRequestsBody } from "@webapp/search/models/search-api.models";

export type TeamsSearchConditionSettings = {
  activeTeamsOnly?: boolean;
  excludedTeamIds?: string[];
};

export function buildTeamsSearchRequest(searchTerm: string, settings: TeamsSearchConditionSettings = {}): ISearchRequestsBody {
  const searchSettings: TeamsSearchConditionSettings = {
    activeTeamsOnly: true,
    ...settings,
  };
  const searchConditions = buildTeamsSearchConditions(searchSettings);

  return {
    collectionName: "teams",
    searchFields: searchTerm ? [{ name: "name" }, { name: "description" }] : [],
    ...(searchConditions.length && { searchConditions }),
  };
}

export function buildTeamsSearchConditions(settings: TeamsSearchConditionSettings = {}): ISearchCondition[] {
  return [
    ...(settings.activeTeamsOnly ? [isActiveSearchCondition()] : []),
    ...(settings.excludedTeamIds ? [getExcludedIdsSearchCondition(settings.excludedTeamIds)] : []),
  ];
}
